export default "__VITE_ASSET__sL8Sawuw__"